// extracted by mini-css-extract-plugin
export default {"input":"MaaltijdenFormUpdate_input__y41Ip"};